import { render } from "./Pivot.vue?vue&type=template&id=78ceb06d&scoped=true"
import script from "./Pivot.vue?vue&type=script&lang=js"
export * from "./Pivot.vue?vue&type=script&lang=js"

import "./Pivot.vue?vue&type=style&index=0&id=78ceb06d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ceb06d"]])

export default __exports__